import '../css/reset.css';
import '../css/fonts.css';
import '../css/style.css';
import App from './app';

window.onload = () => {
	const app = new App();
	window.app = app;
	app.init();
};
